// extracted by mini-css-extract-plugin
export default {"status":"NotFound_status__JngvS","title":"NotFound_title__nvxU6","message":"NotFound_message__DEDbg"};